import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Compass } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { Logo } from '@/components/brand/Logo';

export const NotFoundPage = () => {
  // Halaman ini berada di luar AppLayout, jadi judul tab harus diatur sendiri - 
  // tanpa ini, tab masih menampilkan nama halaman sebelumnya.
  useEffect(() => {
    document.title = 'Halaman tidak ditemukan · Crawel';
  }, []);

  return (
  <div className="flex min-h-screen flex-col items-center justify-center bg-[var(--surface-canvas)] px-4 text-center">
    <Link to="/" className="mb-8">
      <Logo />
    </Link>

    <div className="grid size-14 place-items-center rounded-2xl bg-[var(--surface-raised)] text-[var(--text-muted)] shadow-sm">
      <Compass className="size-7" aria-hidden="true" />
    </div>

    <p className="mt-6 text-5xl font-extrabold tabular text-[var(--text-primary)]">404</p>
    <h1 className="mt-2 text-lg font-bold text-[var(--text-primary)]">Halaman tidak ditemukan</h1>
    <p className="mt-2 max-w-sm text-sm leading-relaxed text-[var(--text-muted)]">
      Alamat yang Anda tuju tidak ada, atau mungkin sudah dipindahkan.
    </p>

    <div className="mt-7 flex flex-wrap justify-center gap-2">
      <Link to="/dashboard">
        <Button icon={ArrowLeft}>Kembali ke Dashboard</Button>
      </Link>
      <Link to="/">
        <Button variant="secondary">Ke Beranda</Button>
      </Link>
    </div>
  </div>
  );
};
